<template>
  <button class="hero-button-play" @click="$emit('click')">
    <icon-play class="icon"></icon-play><slot></slot>
  </button>
</template>

<script>
  import {IconPlay} from "@rawlplug/rawlplug-design-components-library"

  export default {
    name: "HeroButtonPlay",
    components: {IconPlay}
  }
</script>

<style lang="scss" scoped>
  @import "~@rawlplug/rawlplug-design-style-framework/src/scss/rawlplug";
  .hero-button-play {
    @include make-button-base;
    color: $color-rwl-white-100;
    align-items: center;
    .icon {
      transform: scale(0.85);
    }
  }
</style>
